import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type {
  PricingDiscountCodesResponse,
  PricingMealRatePlansResponse,
  PricingRatePlansResponse,
} from '~/http/pricing/types'

export class PricingAPI extends Http {
  discountCodes = (): Promise<PricingDiscountCodesResponse> => {
    return this.callAuthWithPropertyAPI<null, PricingDiscountCodesResponse>(
      HttpMethod.GET,
      {
        path: APIPaths.PRICING_DISCOUNT_CODES_LIST,
      },
      null,
    )
  }

  ratePlans = (): Promise<PricingRatePlansResponse> => {
    return this.callAuthWithPropertyAPI<null, PricingRatePlansResponse>(HttpMethod.GET, {
      path: APIPaths.PRICING_RATE_PLAN_LIST,
    })
  }

  otaRatePlans = (otaId: number): Promise<PricingRatePlansResponse> => {
    return this.callAuthWithPropertyAPI<null, PricingRatePlansResponse>(HttpMethod.GET, {
      path: APIPaths.PRICING_OTA_RATE_PLANS,
      params: {
        otaId: otaId,
      },
    })
  }

  mealRatePlans = (): Promise<PricingMealRatePlansResponse> => {
    return this.callAuthWithPropertyAPI<null, PricingMealRatePlansResponse>(HttpMethod.GET, {
      path: APIPaths.PRICING_MEAL_RATE_PLAN_LIST,
    })
  }
}
export const usePricingAPI = (): PricingAPI => {
  return new PricingAPI()
}
